var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { StoreContext } from '@/app/uistore/Rootstore';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { Image } from "@chakra-ui/react";
import hicon from "@/assets/wicon_header.png";
export class ProfileDialogState {
    constructor() {
        this.open = false;
        this.basedialogState = new BaseDialogState();
        this.password = "";
        makeObservable(this);
        this.basedialogState.setHeaderLabel("My Profile");
        this.basedialogState.setDisableOkButton(true);
    }
    saveMasterPassword() {
    }
    setOpen(open) {
        this.open = open;
        this.basedialogState.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ProfileDialogState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProfileDialogState.prototype, "password", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProfileDialogState.prototype, "setOpen", null);
let ProfileDialog = class ProfileDialog extends React.Component {
    constructor(prop) {
        super(prop);
        this.props.state.basedialogState.onClose = () => this.closed();
        this.props.state.basedialogState.onOpen = () => this.opened();
    }
    componentDidMount() {
        const rstore = this.context;
        this.opened();
    }
    componentDidUpdate() {
        this.updateDialog();
    }
    opened() {
        const rstore = this.context;
        // rstore.adminStore.checkHasMasterKey();
        this.updateDialog();
    }
    closed() {
        const rstore = this.context;
        rstore.adminStore.reset();
        this.props.state.setOpen(false);
    }
    updateDialog() {
        const rstore = this.context;
        this.props.state.basedialogState.setDisableOkButton(true);
        this.props.state.basedialogState.setOkLabel('Update');
        this.props.state.basedialogState.onOk = () => rstore.adminStore.getAndShowMasterKey();
    }
    componentWillUnmount() {
        const rstore = this.context;
        rstore.adminStore.reset();
    }
    setMasterPasswordInput(input) {
        const rstore = this.context;
        this.enableButton(input);
        rstore.adminStore.setMasterPasswordInput(input);
    }
    enableButton(input) {
        if (input) {
            this.props.state.basedialogState.setDisableOkButton(false);
        }
        else {
            this.props.state.basedialogState.setDisableOkButton(true);
        }
    }
    dialog() {
        const rstore = this.context;
        return (React.createElement(Box, { w: '100%', mt: '30px' }, !rstore.userStore.loading && React.createElement(Box, null,
            React.createElement(UserProfile, null))));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
ProfileDialog.contextType = StoreContext;
ProfileDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ProfileDialog);
export { ProfileDialog };
let UserProfile = class UserProfile extends React.Component {
    render() {
        var _a, _b;
        const rootstore = this.context;
        return React.createElement(Box, { width: '100%' },
            React.createElement(Box, { w: '100%' },
                React.createElement(Text, { fontSize: 18, fontWeight: 'bold', color: '#808080' }, 'Name')),
            React.createElement(Box, { w: '100%' },
                React.createElement(Text, { fontSize: 14, fontWeight: 'bold', color: '#404040' }, (_a = rootstore.userStore.username) !== null && _a !== void 0 ? _a : 'Missing')),
            React.createElement(Box, { w: '100%' },
                React.createElement(Text, { fontSize: 18, fontWeight: 'bold', color: '#808080' }, 'Email')),
            React.createElement(Box, { w: '100%' },
                React.createElement(Text, { fontSize: 14, fontWeight: 'bold', color: '#404040' }, (_b = rootstore.userStore.useremail) !== null && _b !== void 0 ? _b : 'Missing')));
    }
};
UserProfile.contextType = StoreContext;
UserProfile = __decorate([
    observer
], UserProfile);
let MyprofileImage = class MyprofileImage extends React.Component {
    componentDidMount() {
    }
    render() {
        const rootstore = this.context;
        return React.createElement(Box, null,
            React.createElement(Box, { marginLeft: '10px', marginTop: '5px' },
                React.createElement(Image, { src: hicon, style: { width: '50px', height: '50px' } })));
    }
};
MyprofileImage.contextType = StoreContext;
MyprofileImage = __decorate([
    observer
], MyprofileImage);
